import type { UserProfile, LinkedDocument } from "@/domains/pm/types";

/**
 * The fixed quick-reaction palette for the project message board. Kept in sync
 * with the CHECK constraint on public.project_message_reactions.emoji — adding
 * an emoji here without the matching migration will fail the insert at the DB.
 */
export const QUICK_REACTIONS = ["👍", "✅", "❤️", "😄", "🎉"] as const;
export type QuickReaction = (typeof QUICK_REACTIONS)[number];

/** Aggregated reaction count for one emoji on one message. */
export interface ReactionSummary {
  emoji: string;
  count: number;
  /** Whether the viewing user is one of the reactors. */
  reactedByMe: boolean;
}

/** The quoted snippet shown above a reply. Resolved from the parent message. */
export interface ReplySnippet {
  id: number;
  authorName: string;
  body: string;
  /** True when the parent is soft-deleted or inaccessible — render a placeholder. */
  deleted: boolean;
}

/** One message in a project's chat feed (public.project_messages). */
export interface ProjectMessage {
  id: number;
  building_project_id: number;
  org_id: string;
  building_id: number;
  author_id: number;
  body: string;
  reply_to_id: number | null;
  created_at: string;
  modified_at: string | null;
  modified_by: number | null;
  /** Set when the message has been soft-deleted; the feed shows a tombstone. */
  deleted_at: string | null;
  // Hydrated by the repository (no FK embeds — same batching as listComments).
  author?: UserProfile;
  reply_to?: ReplySnippet | null;
  linked_documents: LinkedDocument[];
  reactions: ReactionSummary[];
}
